+function () {

	"use strict";

	var sliderSets = $('.slider-set');

	if (sliderSets.length == 0) {
		return;
	}

	var history = new DbbHistoryState(true, window.appConfig.pagePathname);
	//history.setNativePushStateSupport(false);
	
	sliderSets.find('a.slider__title').click(function(event) {
		if (event.preventDefault) {
			event.preventDefault();
		}
		else {
			event.returnValue = false;
		}
		
		$(this).blur();
		
		var state = {
			'sliderId' : '',
			'href': ''
		};
		
		if ($(this).hasClass('collapsed')) {
			// It will open the slider
			state.sliderId = $(this).data('target').replace(/^#/, '');
			state.href = this.href;
		}
		
		history.replace(state, state.href, state.href.replace(window.appConfig.websiteBaseUrl + '/' + window.appConfig.websiteRelativePagePathname + '/', ''));
	});
	
	
	$(window).on('onDbbHistoryStatePop', function () {
		if (history.getState() == null || $.isEmptyObject(history.getState())) {
			if (($('.modal:not(#videoModal)').is('visible')) || ($('.modal:not(#videoModal)').data('bs.modal'))) {
				$('.modal').off('hide.bs.modal.program').modal('hide');
			}
			return;
		}

		var teamMemberLink = profilesContainer.find('a[href="' + history.getState().href + '"]');

		teamMemberLink.trigger('click');
	});
	
	$(document).on('ready.slider.open', function () {

		var hash = window.location.hash.replace(/^(#!)/, '');

		if (hash != '') {
			var sliderUrl = window.appConfig.websiteBaseUrl + '/' + window.appConfig.websiteRelativePagePathname + '/' + hash;

			sliderSets.find('a[href="' + sliderUrl + '"]').addClass('load-on-page-request');
		}

		$('.load-on-page-request').each(function () {
			$(this).trigger('click', true);
			
			// Let's also update the href because we would like to move the scroll to correspondent slider
			window.location.href = $(this).data('target') + '-title';
		}); 
		
		
	});

}(window.jQuery);
